import styled from '@emotion/styled';

const StyledSvg = styled.svg<{ responsive: boolean }>`
  display: block;
`;

export { StyledSvg };
